(() => {
  'use-strict';

  const body = document.querySelector('body');

  let currentScrollPos = 0;
  const scroll = () => {
    const newScrollPos = (body.getBoundingClientRect()).top;

    if (newScrollPos >= currentScrollPos) {
      body.setAttribute('data-scroll', 'up');
    } else {
      body.setAttribute('data-scroll', 'down');
    }
    if (newScrollPos === 0) {
      body.classList.remove('-headerIsSticky');
    } else {
      body.classList.add('-headerIsSticky');
    }
    currentScrollPos = newScrollPos;
  };

  window.addEventListener('scroll', () => {
    window.requestAnimationFrame(() => {
      scroll();
    });
  });

  scroll();

  const siteHeader = document.querySelector('.js-site-header');
  // Listen to the breakpoint event
  if (siteHeader !== null) {
    const siteHeaderNav = siteHeader.querySelector('.js-site-header-nav');
    document.addEventListener('breakpointChange', (event) => {
      const mainMenuInnersLvl1 = siteHeader.querySelectorAll('.menu-inner.lvl-1');

      if (!(event.detail.breakpoints.includes('desktop-large'))) {
        // Mobile / tablet case
        // Insert the nav (burger + main menu) at the end on the site-header-inner
        const siteHeaderInner = siteHeader.querySelector('.js-site-header-inner');
        siteHeaderInner.insertBefore(siteHeaderNav, null);
        mainMenuInnersLvl1.forEach((menuInner) => {
          // Insert the category link at the before on the menu-list.lvl-1
          const link = menuInner.querySelector('.js-category-link');
          const menuList = menuInner.querySelector('.menu-list');
          menuList.before(link);
        });
      } else if (!(event.detail.initial)) {
        // Desktop case
        // Insert the nav (burger + main menu) before site-header-tools
        const siteHeaderTools = siteHeader.querySelector('.js-site-header-tools');
        siteHeaderTools.before(siteHeaderNav);
        mainMenuInnersLvl1.forEach((menuInner) => {
          // Insert the category link at the end on the menu-inner.lvl-1
          const link = menuInner.querySelector('.js-category-link');
          menuInner.insertBefore(link, null);
        });
      }
    }, false);
  }
})();
